import React from "react";

export const Scroll = () => {
  return (
    <div className="scroll-container">
      <div className="chevron"></div>
      <div className="chevron"></div>
      <div className="chevron"></div>
    </div>
  );
};
